import { MapPin, MessageCircle, Instagram } from "lucide-react";
import { Reveal } from "../motion";
import { useLang } from "../../lib/i18n";

export const Footer = ({ settings }) => {
  const { t } = useLang();
  const weekly = settings?.weekly || {};
  const digits = (settings?.whatsapp || "").replace(/\D/g, "");
  const days = t("days");

  return (
    <footer id="contact" className="bg-espresso text-cream py-24" data-testid="footer-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <Reveal>
            <img src="/logo.png" alt="Nadou Skin" className="h-14 w-auto brightness-[1.9]" />
            <p className="mt-6 text-sm text-cream/60 font-light leading-relaxed max-w-sm">
              {t("footer.desc")}
            </p>
          </Reveal>
        </div>
        <div className="lg:col-span-4">
          <Reveal delay={0.1}>
            <h3 className="text-[12px] tracking-[0.28em] uppercase text-gold mb-6">{t("footer.contact")}</h3>
            <ul className="space-y-4 text-sm font-light">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-taupe shrink-0" strokeWidth={1.5} />
                <span className="text-cream/75" data-testid="footer-address">{settings?.address || ""}</span>
              </li>
              <li>
                <a
                  href={`https://wa.me/${digits}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-whatsapp-link"
                  className="flex items-center gap-3 text-cream/75 hover:text-cream transition-colors duration-300"
                >
                  <MessageCircle className="w-4 h-4 text-taupe shrink-0" strokeWidth={1.5} />
                  {settings?.whatsapp}
                </a>
              </li>
              {settings?.instagram && (
                <li>
                  <a
                    href={settings.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="footer-instagram-link"
                    className="flex items-center gap-3 text-cream/75 hover:text-cream transition-colors duration-300"
                  >
                    <Instagram className="w-4 h-4 text-taupe shrink-0" strokeWidth={1.5} />
                    Instagram
                  </a>
                </li>
              )}
            </ul>
          </Reveal>
        </div>
        <div className="lg:col-span-3">
          <Reveal delay={0.2}>
            <h3 className="text-[12px] tracking-[0.28em] uppercase text-gold mb-6">{t("footer.hours")}</h3>
            <ul className="space-y-2.5 text-sm font-light" data-testid="footer-hours">
              {days.map((label, k) => {
                const d = weekly[k];
                return (
                  <li key={k} className="flex justify-between gap-6 text-cream/70">
                    <span>{label}</span>
                    <span className={d?.open ? "text-cream" : "text-cream/40 italic"}>
                      {d?.open ? `${d.start} — ${d.end}` : t("footer.closed")}
                    </span>
                  </li>
                );
              })}
            </ul>
          </Reveal>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-16 pt-8 border-t border-cream/10 flex flex-wrap justify-between gap-4 text-xs text-cream/40">
        <span>© {new Date().getFullYear()} Nadou Skin — {t("footer.rights")}</span>
        <a href="/admin/login" data-testid="footer-admin-link" className="hover:text-cream/70 transition-colors duration-300">
          {t("footer.pro")}
        </a>
      </div>
    </footer>
  );
};
